<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Postulaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Postulaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-file-alt me-2 text-primary"></i>
                          Gestión de Postulaciones
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra las postulaciones de hidrocarburos y sus
                          estados
                        </p>
                      </div>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal-form-postulacion-export"
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.reportes.postulacionExport',
                            )
                          "
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <div class="row">
                      <!-- Filtro Empresa -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.slct_empresa"
                          placeholder="Buscar empresa..."
                          label="razon_social"
                          class="form-control-sm p-0"
                          :options="empresas"
                          :filterable="false"
                          @search="buscarEmpresas"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <!-- Filtro Fecha -->
                      <div class="col-md-3 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha"
                          @change="getIndex()"
                        />
                      </div>

                      <!-- Filtro Sitio -->
                      <div class="col-md-3 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio Origen
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="slct_sitio"
                          placeholder="Buscar sitio..."
                          label="nombre"
                          class="form-control-sm p-0"
                          :options="sitios"
                          :filterable="false"
                          @search="buscarSitios"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <div class="col-md-3 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio Destino
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="slct_sitio_destino"
                          placeholder="Buscar sitio..."
                          label="nombre"
                          class="form-control-sm p-0"
                          :options="sitios"
                          :filterable="false"
                          @search="buscarSitios"
                          @input="getIndex()"
                        ></v-select>
                      </div>
                      <!-- Filtro Nominación -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-tag me-1"></i>
                          Nominación
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.slct_nominacion"
                          placeholder="Buscar nominación..."
                          label="nombre"
                          class="form-control-sm p-0"
                          :options="nominaciones"
                          :filterable="false"
                          @search="buscarNominaciones"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Botón limpiar filtros -->
                      <div class="col-md-12 col-lg-2 d-flex align-items-end">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm w-100"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Postulaciones
                  </h6>
                  <span class="badge bg-primary">
                    {{ postulaciones.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table
                    class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center" style="width: 60px;">
                          <i class="fas fa-hashtag"></i>
                        </th>
                        <th>
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </th>
                        <th>
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio Origen
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio Destino
                        </th>
                        <th>
                          <i class="fas fa-tag me-1"></i>
                          Nominación
                        </th>
                        <th class="text-center">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </th>
                        <th class="text-center" style="width: 120px;">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(postulacion, index) in postulaciones.data"
                        :key="index"
                      >
                        <td class="text-center">
                          <span class="badge bg-secondary">{{
                            index + 1
                          }}</span>
                          <span
                            v-if="
                              postulacion.cantidad && postulacion.cantidad > 1
                            "
                            class="badge bg-info ms-1"
                            :title="
                              `${postulacion.cantidad} postulaciones agrupadas`
                            "
                          >
                            <i class="fas fa-layer-group me-1"></i
                            >{{ postulacion.cantidad }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              postulacion.empresa != null
                                ? postulacion.empresa.razon_social
                                : "No encontrada"
                            }}
                          </span>
                        </td>
                        <td>
                          {{ postulacion.solicitud_diaria.fecha }}
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ postulacion.solicitud_diaria.sitio.nombre }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              postulacion.sitio_destino?.nombre ?? "Sin Asignar"
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ postulacion.solicitud_diaria.nominacion.nombre }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="d-flex flex-column gap-1">
                            <span
                              class="badge"
                              :class="[
                                postulacion.solicitud_diaria.solicitudes_diaria_empresas.some(
                                  (det) =>
                                    det.estado == 1 &&
                                    det.empresa_id == postulacion.empresa_id,
                                )
                                  ? 'bg-warning'
                                  : 'bg-success',
                              ]"
                            >
                              {{
                                postulacion.solicitud_diaria.solicitudes_diaria_empresas.some(
                                  (det) =>
                                    det.estado == 1 &&
                                    det.empresa_id == postulacion.empresa_id,
                                )
                                  ? "NO POSTULADO"
                                  : "POSTULADO"
                              }}
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <div v-if="postulacion.empresa.contratos.length == 0">
                            <span
                              class="badge bg-warning"
                              style="font-size: 0.8em"
                            >
                              <i class="fas fa-ban me-1"></i>
                              Contrato Inhabilitado
                            </span>
                          </div>
                          <div
                            v-else
                            class="btn-group btn-group-sm"
                            role="group"
                          >
                            <button
                              type="button"
                              :class="
                                new Date(
                                  postulacion.solicitud_diaria.fecha + ' 00:00',
                                ) >= new Date()
                                  ? 'btn btn-outline-primary'
                                  : 'btn btn-outline-secondary'
                              "
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.postulaciones.show',
                                )
                              "
                              @click="
                                edit(
                                  postulacion.ids && postulacion.ids.length > 0
                                    ? postulacion.ids[0]
                                    : postulacion.id,
                                  postulacion.empresa_id,
                                  postulacion.solicitud_diaria.id,
                                )
                              "
                              :title="
                                new Date(
                                  postulacion.solicitud_diaria.fecha + ' 00:00',
                                ) >= new Date()
                                  ? 'Editar'
                                  : 'Ver'
                              "
                            >
                              <i
                                :class="
                                  new Date(
                                    postulacion.solicitud_diaria.fecha +
                                      ' 00:00',
                                  ) >= new Date()
                                    ? 'fas fa-edit'
                                    : 'fas fa-eye'
                                "
                              ></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can(
                                  'hidrocarburos.postulaciones.editcitas',
                                )
                              "
                              data-toggle="modal"
                              data-target="#modal-citas-postulacion"
                              title="Ver citas"
                              @click="abrirModalCitas(postulacion)"
                            >
                              <i class="fas fa-calendar-alt"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="!postulaciones.data || postulaciones.data.length === 0"
                  class="text-center py-5"
                >
                  <h5 class="text-muted">No hay postulaciones para mostrar</h5>

                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Postulaciones..</p>
                  </div>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="postulaciones.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        postulaciones.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        postulaciones.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        postulaciones.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="postulaciones"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    align="right"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <PostulacionExport ref="PostulacionExport" />
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-citas-postulacion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-citas-postulacion-label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div
          class="modal-content"
          :class="$store.getters.getDarkMode ? 'bg-dark text-light' : ''"
        >
          <div class="modal-header">
            <h5 class="modal-title" id="modal-citas-postulacion-label">
              <i class="fas fa-clock me-2"></i>
              Rutas y citas de postulación
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body modal-citas-body">
            <div
              v-if="!modalCita.items.length"
              class="alert alert-info mb-0"
              role="alert"
            >
              No hay datos de cita para esta postulación.
            </div>
            <div v-else class="modal-citas-table-wrap">
              <table
                class="table table-sm table-striped mb-0 table-responsive table-bordered"
                :class="$store.getters.getDarkMode ? 'table-dark' : ''"
              >
                <thead>
                  <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">Ruta</th>
                    <th class="text-center">
                      Mercancía
                    </th>
                    <th class="text-center">
                      Tipo Vehículo
                    </th>
                    <th class="text-center">Turno</th>
                    <th class="text-center">
                      Tipo
                    </th>
                    <th class="text-center">Cita turne</th>
                    <th class="text-center">Cita cargue</th>
                    <th class="text-center">Estado viaje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in modalCita.items"
                    :key="item.det_solicitud_diaria_id || i"
                  >
                    <td class="text-center align-middle" style="min-width: 50px;">{{ i + 1 }}</td>
                    <td class="modal-citas-ruta-td text-center align-middle">
                      <v-select
                        class="form-control form-control-sm w-100 p-0"
                        :options="listasForms.rutas"
                        :reduce="(ruta) => ruta.id"
                        :placeholder="item.ruta || 'Selecciona una ruta'"
                        v-model="item.ruta_id"
                        label="nombre"
                        :append-to-body="true"
                        :calculate-position="posicionarDropdown"
                        @search="buscarRutas"
                      />
                    </td>
                    <td class="text-center align-middle" style="min-width: 100px;">
                      <span
                        :class="
                          $store.getters.getDarkMode
                            ? 'text-light'
                            : 'text-dark'
                        "
                      >
                        {{ item.mercancia_nombre || "—" }}
                      </span>
                    </td>
                    <td class="text-center align-middle" style="min-width: 190px;">
                      <v-select
                        class="form-control form-control-sm w-100 p-0"
                        :options="listasForms.tipos_vehiculos"
                        placeholder="Selecciona un tipo de vehículo"
                        v-model="item.tipo_vehiculo"
                        label="nombre"
                        :append-to-body="true"
                        :calculate-position="posicionarDropdown"
                        @input="
                          item.tipo_vehiculo_id = item.tipo_vehiculo
                            ? item.tipo_vehiculo.id
                            : null;
                          item.tipo_vehiculo_nombre = item.tipo_vehiculo
                            ? item.tipo_vehiculo.nombre
                            : null;
                        "
                      />
                    </td>
                    <td class="text-center align-middle" style="min-width: 100px;">
                      <input
                        type="number"
                        class="form-control form-control-sm"
                        v-model="item.turno"
                      />
                    </td>
                    <td class="text-center align-middle" style="min-width: 100px;">
                      <span
                        :class="
                          $store.getters.getDarkMode
                            ? 'text-light'
                            : 'text-dark'
                        "
                      >
                        {{ item.tipo_solicitud || "—" }}
                      </span>
                    </td>
                    <td class="text-center align-middle" style="min-width: 190px;">
                      <input
                        type="datetime-local"
                        class="form-control form-control-sm"
                        :class="{
                          'is-invalid': citaCargueMenorQueTurne(item),
                        }"
                        v-model="item.cita_turne"
                      />
                    </td>
                    <td class="text-center align-middle" style="min-width: 190px;">
                      <input
                        type="datetime-local"
                        class="form-control form-control-sm"
                        :class="{
                          'is-invalid': citaCargueMenorQueTurne(item),
                        }"
                        :min="item.cita_turne || null"
                        v-model="item.cita_cargue"
                      />
                      <small
                        v-if="citaCargueMenorQueTurne(item)"
                        class="text-danger d-block"
                      >
                        Cita cargue no puede ser menor a cita turne
                      </small>
                    </td>
                    <td style="min-width: 180px;">
                      <div
                        v-if="
                          !(
                            item.det_postulaciones &&
                            item.det_postulaciones.length
                          )
                        "
                        class="text-muted small"
                      >
                        Sin postulación
                      </div>
                      <div
                        v-for="(postulacion, j) in item.det_postulaciones || []"
                        :key="j"
                        class="mb-2"
                      >
                        <div class="small font-weight-bold mb-1">
                          Postulación #{{ i + 1 }}
                        </div>
                        <span
                          class="badge"
                          :class="
                            [1, 4, 6].includes(Number(postulacion.estado))
                              ? 'bg-success'
                              : 'bg-secondary'
                          "
                        >
                          {{
                            postulacion.estado_label ||
                              postulacion.estado ||
                              "Sin estado"
                          }}
                        </span>
                        <div class="small mt-1">
                          Viaje:
                          {{
                            postulacion.viaje_id
                              ? "#" + postulacion.viaje_id
                              : "Sin número"
                          }}
                        </div>
                        <div class="small text-muted">
                          Cargue:
                          {{ postulacion.fecha_llegada_cargue || "Sin fecha" }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-if="$store.getters.can('hidrocarburos.postulaciones.editcitas')"
              @click="guardarCita()"
            >
              <i class="fas fa-save me-1"></i>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import pagination from "laravel-vue-pagination";
import PostulacionExport from "./PostulacionExport";
import Loading from "../../../../components/Loading";

export default {
  name: "PostulacionIndex",
  components: {
    pagination,
    vSelect,
    Loading,
    PostulacionExport,
  },
  data() {
    return {
      storageKeyFiltros: "hidrocarburos_postulacion_filtros",
      distancia: null,
      slct_sitio_destino: {},
      postulaciones: {},
      hoy: new Date(),
      cargando: false,
      filtros: {
        empresa_id: null,
        sitio_id: null,
        sitio_destino_id: null,
        fecha: null,
        userEmpresa: null,
        nominacion_id: null,
      },
      listasForms: {
        slct_empresa: [],
        estados: [],
        estadosViaje: [],
        slct_nominacion: [],
        rutas: [],
        tipos_vehiculos: [],
        productos: [],
      },
      nominaciones: [],
      sitios: [],
      slct_sitio: [],
      empresas: [],
      modalCita: {
        postulacion: null,
        items: [],
        todosEditables: false,
      },
    };
  },
  methods: {
    posicionarDropdown(dropdownList, component, { width }) {
      const toggle = component.$refs.toggle;
      if (!toggle) return;

      const rect = toggle.getBoundingClientRect();
      dropdownList.style.position = "fixed";
      dropdownList.style.top = `${rect.bottom}px`;
      dropdownList.style.left = `${rect.left}px`;
      dropdownList.style.width = width || `${rect.width}px`;
      dropdownList.style.zIndex = "2000";
    },

    async getIndex(page = 1) {
      this.cargando = true;
      this.getUserEmpresa();
      const stored = this.getStoredFiltros();
      if (stored) {
        this.filtros.empresa_id = stored.filtros.empresa_id ?? null;
        this.filtros.sitio_id = stored.filtros.sitio_id ?? null;
        this.filtros.sitio_destino_id = stored.filtros.sitio_destino_id ?? null;
        this.filtros.fecha = stored.filtros.fecha || null;
        this.filtros.nominacion_id = stored.filtros.nominacion_id ?? null;
        this.listasForms.slct_empresa = stored.slct_empresa || null;
        this.slct_sitio = stored.slct_sitio || null;
        this.slct_sitio_destino = stored.slct_sitio_destino || null;
        this.listasForms.slct_nominacion = stored.slct_nominacion || null;
        this.clearStoredFiltros();
      } else {
        this.filtros.empresa_id = null;
        this.filtros.nominacion_id = null;
        this.filtros.sitio_destino_id = null;
        this.filtros.sitio_id = null;
        // fecha no se resetea: viene del input v-model y no de un select
        if (this.listasForms.slct_empresa) {
          this.filtros.empresa_id = this.listasForms.slct_empresa.id;
        }
        if (this.slct_sitio) {
          this.filtros.sitio_id = this.slct_sitio.id;
        }
        if (this.slct_sitio_destino) {
          this.filtros.sitio_destino_id = this.slct_sitio_destino.id;
        }
        if (this.listasForms.slct_nominacion) {
          this.filtros.nominacion_id = this.listasForms.slct_nominacion.id;
        }
      }
      await axios
        .get("/api/hidrocarburos/postulaciones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.postulaciones = response.data;
          // Agrupar los datos
          if (this.postulaciones.data) {
            this.postulaciones.data = this.agruparPostulaciones(
              this.postulaciones.data,
            );
          }
          this.cargando = false;
        });
      this.cargando = false;
    },

    async abrirModalCitas(postulacion) {
      this.cargando = true;
      try {
        await this.getTiposVehiculos();

        const { data } = await axios.get(
          "/api/hidrocarburos/postulaciones/citas",
          {
            params: {
              empresa_id: postulacion.empresa_id,
              solicitud_diaria_id: postulacion.solicitud_diaria?.id,
              sitio_destino_id: postulacion.sitio_destino_id ?? null,
            },
          },
        );
        const items = (data.items || []).map((item) => {
          const tipoVehiculo =
            this.listasForms.tipos_vehiculos.find(
              (tipo) => Number(tipo.id) === Number(item.tipo_vehiculo_id),
            ) ||
            (item.tipo_vehiculo_id
              ? {
                  id: item.tipo_vehiculo_id,
                  nombre: item.tipo_vehiculo_nombre || "",
                }
              : null);

          return {
            ...item,
            ruta_id: item.ruta_id ?? null,
            ruta_nombre: item.ruta_nombre ?? null,
            cita_turne: item.cita_turne,
            cita_cargue:
              item.fecha_cita && item.cita_cargue
                ? `${item.fecha_cita} ${item.cita_cargue}`
                : null,
            tipo_vehiculo_id: item.tipo_vehiculo_id ?? null,
            tipo_vehiculo_nombre:
              tipoVehiculo?.nombre || item.tipo_vehiculo_nombre || null,
            tipo_vehiculo: tipoVehiculo,
          };
        });

        this.modalCita = {
          postulacion,
          items,
          todosEditables:
            typeof data.todos_editables === "boolean"
              ? data.todos_editables
              : items.length > 0 && items.every((item) => item.puede_editar),
        };
      } catch (error) {
        this.modalCita = {
          postulacion,
          items: [],
          todosEditables: false,
        };
        this.$swal({
          icon: "error",
          title: "No se pudo cargar la información de citas",
          text:
            error?.response?.data?.message ||
            "Intenta nuevamente en unos segundos.",
        });
      } finally {
        this.cargando = false;
      }
    },

    citaCargueMenorQueTurne(item) {
      if (!item?.cita_turne || !item?.cita_cargue) {
        return false;
      }
      const turne = moment(item.cita_turne);
      const cargue = moment(item.cita_cargue);
      if (!turne.isValid() || !cargue.isValid()) {
        return false;
      }
      return cargue.isBefore(turne);
    },

    async guardarCita() {
      if (!this.$store.getters.can("hidrocarburos.postulaciones.editcitas")) {
        return;
      }
      const itemsEditables = (this.modalCita.items || []).filter(
        (item) => item.puede_editar,
      );
      if (!itemsEditables.length) {
        return;
      }

      const itemsInvalidos = itemsEditables.filter((item) =>
        this.citaCargueMenorQueTurne(item),
      );
      if (itemsInvalidos.length) {
        this.$swal({
          icon: "warning",
          title: "Fechas inválidas",
          text:
            "La cita de cargue no puede ser menor a la cita turne. Revisa las filas marcadas en rojo.",
        });
        return;
      }

      this.cargando = true;
      try {
        const payload = {
          items: itemsEditables.map((item) => ({
            det_solicitud_diaria_id: item.det_solicitud_diaria_id,
            cita_turne: item.cita_turne || null,
            cita_cargue:
              moment(item.cita_cargue).format("YYYY-MM-DD HH:mm:ss") || null,
            tipo_vehiculo_id: item.tipo_vehiculo_id || null,
            turno: item.turno,
            ruta_id: item.ruta_id || null,
          })),
        };

        await axios.put("/api/hidrocarburos/postulaciones/saveCitas", payload);

        this.$swal({
          icon: "success",
          title: "Citas actualizadas",
          text: "Citas actualizadas correctamente.",
          timer: 1800,
          showConfirmButton: false,
        });

        await this.abrirModalCitas(this.modalCita.postulacion);
        this.getIndex(this.postulaciones.current_page || 1);
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "No se pudieron guardar las citas",
          text:
            error?.response?.data?.message ||
            "Intenta nuevamente en unos segundos.",
        });
      } finally {
        this.cargando = false;
      }
    },

    construirDetalleCita(postulacion) {
      const estadoViaje =
        postulacion.estado_viaje ??
        postulacion.estado_viaje_id ??
        postulacion.viaje?.estado_viaje ??
        postulacion.viaje?.estado_viaje_id ??
        postulacion.estado ??
        postulacion.estado_id ??
        null;
      return {
        id: postulacion.id,
        ruta: `${postulacion.solicitud_diaria?.sitio?.nombre ||
          "Sin Asignar"} -> ${postulacion.sitio_destino?.nombre ||
          "Sin Asignar"}`,
        cita_turne:
          postulacion.cita_enturne ??
          postulacion.cita_turne ??
          postulacion.viaje?.cita_turne ??
          null,
        cita_cargue:
          postulacion.fecha_cita && postulacion.cita_cargue
            ? `${postulacion.fecha_cita} ${postulacion.cita_cargue}`
            : null,
        estado_viaje: estadoViaje,
        estado_viaje_label:
          postulacion.nEstado ??
          postulacion.estado_nombre ??
          this.listasForms.estadosViaje.find(
            (estado) => Number(estado.numeracion) === Number(estadoViaje),
          )?.nombre ??
          this.listasForms.estadosViaje.find(
            (estado) => Number(estado.numeracion) === Number(estadoViaje),
          )?.descripcion ??
          this.listasForms.estadosViaje.find(
            (estado) => Number(estado.numeracion) === Number(estadoViaje),
          )?.nEstado ??
          null,
      };
    },

    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/sitios/lista?sitio=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.sitios = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarNominaciones(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/hidrocarburos/nominacion/list?nombre=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.nominaciones = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRutas(search, loading) {
      if (search != "") {
        let me = this;
        const sitio_id =
          this.modalCita?.postulacion?.solicitud_diaria?.sitio?.id ||
          this.modalCita?.postulacion?.solicitud_diaria?.sitio_id ||
          null;
        loading(true);
        var url =
          "api/admin/rutas/lista?origen_id=" + sitio_id + "&ruta=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.listasForms.rutas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            loading(false);
            me.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    async getTiposVehiculos() {
      try {
        const { data } = await axios.get("/api/admin/tiposVehiculos/lista", {
          params: {
            linea_negocio_id: 2,
            estado: 1,
          },
        });
        // Algunos endpoints devuelven array directo; otros { data: [] }
        const lista = Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
          ? data.data
          : [];
        this.listasForms.tipos_vehiculos = lista;
      } catch (error) {
        this.listasForms.tipos_vehiculos = [];
        this.$swal({
          icon: "error",
          title: "Ocurrio un error" + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    // Se busca las empresas realcionadas al usuario
    getUserEmpresa() {
      this.filtros.userEmpresa = [];
      for (const iterator of this.$store.getters.getUser.empresas) {
        this.filtros.userEmpresa.push(iterator.id);
      }
    },

    async getEstados() {
      await axios.get("/api/lista/36").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    async getEstadosViaje() {
      await axios.get("/api/lista/65").then((response) => {
        this.listasForms.estadosViaje = response.data;
      });
    },

    getStoredFiltros() {
      try {
        const raw = sessionStorage.getItem(this.storageKeyFiltros);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },

    setStoredFiltros() {
      try {
        const payload = {
          filtros: {
            empresa_id: this.filtros.empresa_id,
            sitio_id: this.filtros.sitio_id,
            sitio_destino_id: this.filtros.sitio_destino_id,
            fecha: this.filtros.fecha,
            nominacion_id: this.filtros.nominacion_id,
          },
          slct_empresa:
            this.listasForms.slct_empresa &&
            (this.listasForms.slct_empresa.id ||
              this.listasForms.slct_empresa.razon_social)
              ? {
                  id: this.listasForms.slct_empresa.id,
                  razon_social:
                    this.listasForms.slct_empresa.razon_social || "",
                }
              : null,
          slct_sitio:
            this.slct_sitio && (this.slct_sitio.id || this.slct_sitio.nombre)
              ? { id: this.slct_sitio.id, nombre: this.slct_sitio.nombre || "" }
              : null,
          slct_sitio_destino:
            this.slct_sitio_destino &&
            (this.slct_sitio_destino.id || this.slct_sitio_destino.nombre)
              ? {
                  id: this.slct_sitio_destino.id,
                  nombre: this.slct_sitio_destino.nombre || "",
                }
              : null,
          slct_nominacion:
            this.listasForms.slct_nominacion &&
            (this.listasForms.slct_nominacion.id ||
              this.listasForms.slct_nominacion.nombre)
              ? {
                  id: this.listasForms.slct_nominacion.id,
                  nombre: this.listasForms.slct_nominacion.nombre || "",
                }
              : null,
        };
        sessionStorage.setItem(this.storageKeyFiltros, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage no disponible o fallo al guardar
      }
    },

    clearStoredFiltros() {
      try {
        sessionStorage.removeItem(this.storageKeyFiltros);
      } catch (e) {
        // sessionStorage no disponible o fallo al limpiar
      }
    },

    edit(
      solicitud_diaria_empresa_id,
      empresa_id,
      solicitud_diaria_id,
      estado_id,
      fecha,
    ) {
      this.setStoredFiltros();
      return this.$router.push({
        name: "/Hidrocarburos/PostulacionForm",
        params: {
          solicitud_diaria_empresa_id,
          empresa_id,
          solicitud_diaria_id,
        },
      });
    },

    agruparPostulaciones(postulaciones) {
      // Crear un mapa para agrupar por: empresa_id, solicitud_diaria_id, fecha, sitio_origen_id, sitio_destino_id, nominacion_id
      // Los datos vienen de DetSolicitudDiaria, por lo que el sitio_destino está directamente en el objeto
      const grupos = new Map();

      postulaciones.forEach((postulacion) => {
        // Obtener los valores para la agrupación desde DetSolicitudDiaria
        const empresaId = postulacion.empresa_id;
        const solicitudDiaria = postulacion.solicitud_diaria || {};
        const solicitudDiariaId =
          solicitudDiaria.id || postulacion.solicitud_diaria_id;
        const fecha = solicitudDiaria.fecha || postulacion.solicitudDiariaFecha;
        const sitioOrigen = solicitudDiaria.sitio || {};
        const sitioOrigenId = sitioOrigen.id || solicitudDiaria.sitio_id;
        // El sitio destino viene directamente desde DetSolicitudDiaria
        const sitioDestinoId =
          postulacion.sitio_destino_id ||
          (postulacion.sitio_destino ? postulacion.sitio_destino.id : null) ||
          null;
        const nominacion = solicitudDiaria.nominacion || {};
        const nominacionId = nominacion.id || solicitudDiaria.nominacion_id;

        // Crear una clave única para el grupo
        // Usar 'null' como string para valores nulos para evitar problemas con undefined
        const claveGrupo = `${empresaId || "null"}_${solicitudDiariaId ||
          "null"}_${fecha || "null"}_${sitioOrigenId ||
          "null"}_${sitioDestinoId || "null"}_${nominacionId || "null"}`;

        if (!grupos.has(claveGrupo)) {
          // Crear un nuevo grupo con la primera postulación
          grupos.set(claveGrupo, {
            ...postulacion,
            cantidad: 1,
            ids: [postulacion.id],
            detalles_cita: [this.construirDetalleCita(postulacion)],
          });
        } else {
          // Incrementar la cantidad en el grupo existente
          const grupo = grupos.get(claveGrupo);
          grupo.cantidad += 1;
          if (!grupo.ids) {
            grupo.ids = [];
          }
          grupo.ids.push(postulacion.id);
          if (!grupo.detalles_cita) {
            grupo.detalles_cita = [];
          }
          grupo.detalles_cita.push(this.construirDetalleCita(postulacion));
        }
      });

      // Convertir el Map a un array
      return Array.from(grupos.values());
    },

    limpiarFiltros() {
      this.filtros = {
        empresa_id: null,
        sitio_id: null,
        sitio_destino_id: null,
        fecha: null,
        userEmpresa: null,
        nominacion_id: null,
      };
      this.listasForms.slct_empresa = null;
      this.slct_sitio = null;
      this.slct_sitio_destino = null;
      this.listasForms.slct_nominacion = null;
      this.postulaciones = {};
      this.getIndex();
    },
  },
  async mounted() {
    await this.getIndex();
    await this.getEstados();
    await this.getEstadosViaje();
  },
};
</script>

<style>
#modal-citas-postulacion .modal-citas-ruta-td {
  min-width: 220px;
}

#modal-citas-postulacion .modal-citas-ruta-td .v-select.form-control,
#modal-citas-postulacion .v-select.form-control {
  height: auto;
  min-height: calc(1.5em + 0.5rem + 2px);
}
</style>
